import React from "react";
import { useSearchParams } from "react-router-dom";
import { privacyData } from "../data/privacy";

const PrivacyPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang") || "en";
  const isChinese = lang === "zh";
  const currentLang = isChinese ? "zh" : "en";
  const pageTitle = isChinese ? "隐私政策" : "Privacy Policy";
  const privacies = privacyData[currentLang];

  return (
    <div className="bg-white min-h-screen p-5 md:p-2.5">
      <div className="max-w-3xl mx-auto">
        <div className="py-5">
          <h1 className="text-2xl font-bold text-gray-800 text-center mb-5">
            {pageTitle}
          </h1>

          <div className="mb-8">
            {privacies.map((privacy, index) => (
              <div key={index} className="mb-8">
                <h2 className="text-lg font-semibold text-gray-800 mb-1 leading-tight">
                  {privacy.title}
                </h2>
                <p className="text-base text-gray-600 leading-tight tracking-wide select-text m-0">
                  {privacy.content}
                </p>
              </div>
            ))}
          </div>

          <div className="text-right">
            <p className="text-base font-semibold text-gray-800 select-text m-0">
              gejw@gejw.cn
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
